var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99988 5.26728C3.99988 4.93118 4.13157 4.60884 4.36599 4.37118C4.60041 4.13352 4.91836 4 5.24988 4H17.7499C18.0814 4 18.3993 4.13352 18.6338 4.37118C18.8682 4.60884 18.9999 4.93118 18.9999 5.26728V7.02965C18.9998 7.47775 18.8241 7.90747 18.5115 8.22427L13.9999 12.7983V19.0705C13.9999 19.229 13.96 19.3848 13.8839 19.5231C13.8078 19.6615 13.6981 19.7779 13.5652 19.8612C13.4322 19.9445 13.2805 19.9919 13.1244 19.9991C12.9683 20.0062 12.813 19.9727 12.6732 19.9019L9.57571 18.3321C9.40269 18.2444 9.25717 18.1096 9.15546 17.9428C9.05376 17.7759 8.99988 17.5837 8.99988 17.3876V12.7983L4.48821 8.22427C4.17563 7.90747 3.99997 7.47775 3.99988 7.02965V5.26728ZM5.66654 5.68971V7.02965L10.2999 11.727C10.4161 11.8447 10.5083 11.9844 10.5712 12.1382C10.6341 12.2921 10.6665 12.4569 10.6665 12.6234V16.9956L12.3332 17.8404V12.6234C12.3332 12.2872 12.4649 11.9644 12.6999 11.7279L17.3332 7.0288V5.68971H5.66654Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpicIcon);
export default __webpack_public_path__ + "static/media/epic-icon.b545732b358806e2fffbdb167fa7041d.svg";
export { ForwardRef as ReactComponent };